// src/components/doctor/DeleteAppointmentModal.js
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { X } from 'lucide-react';
import AppointmentService from '../../services/appoinment.service';

const DeleteAppointmentModal = ({ appointment, onClose, onSuccess, formatDate, formatTime }) => {
  const [isDeleting, setIsDeleting] = useState(false);
  
  const handleDelete = async () => {
    try {
      setIsDeleting(true);
      await AppointmentService.delete(appointment.id);
      
      // Notifica il componente padre che l'eliminazione è avvenuta con successo
      onSuccess();
      
    } catch (error) {
      console.error('Errore durante l\'eliminazione dell\'appuntamento:', error);
      alert('Impossibile eliminare l\'appuntamento. Riprova più tardi.');
    } finally {
      setIsDeleting(false);
    }
  };
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-bold text-gray-900">Conferma eliminazione</h3>
          <button 
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        
        <div className="mb-6">
          <p className="text-gray-700 mb-4">
            Sei sicuro di voler eliminare questo appuntamento suggerito?
          </p>
          
          <div className="bg-gray-50 p-4 rounded-md mb-4">
            <div className="text-sm text-gray-700">
              <p className="mb-1"><span className="font-medium">Paziente:</span> {appointment.patient_name || `Paziente #${appointment.patient_id}`}</p>
              <p className="mb-1"><span className="font-medium">Data:</span> {formatDate(appointment.date)}</p>
              <p className="mb-1"><span className="font-medium">Ora:</span> {formatTime(appointment.time)}</p>
              <p><span className="font-medium">Servizio:</span> {appointment.service_name}</p>
            </div>
          </div>
          
          <p className="text-sm text-red-600">
            Questa azione non può essere annullata.
          </p>
        </div>
        
        <div className="flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300 transition-colors"
            disabled={isDeleting}
          >
            Annulla
          </button>
          
          <button
            onClick={handleDelete}
            className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition-colors flex items-center"
            disabled={isDeleting}
          >
            {isDeleting ? (
              <>
                <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Eliminazione in corso...
              </>
            ) : (
              'Elimina appuntamento'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

DeleteAppointmentModal.propTypes = {
  appointment: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  formatDate: PropTypes.func.isRequired,
  formatTime: PropTypes.func.isRequired
};

export default DeleteAppointmentModal;